

















































































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  logout,
  getGuideNoticeClose,
  getAccountInfo,
  getQueryVariable,
  getCurrentBillDate,
  exportFileByBillDate,
  showBillDateMenu,
  getLastMsgReadStatus,
  getLastMsg,
} from "@/services/api";
import store from "@/store";
import AccountBack from "../../assets/img/common/account_back.png";
import Account from "../../assets/img/common/account.svg";
import SMSSvg from "../../assets/img/common/sms.svg";
import HealthCheck from '@/components/health-check.vue';

@Component({
  components: {
    'health-check': HealthCheck
  }
})
export default class YcHeader extends Vue {
  @Prop({
    type: Boolean,
    default() {
      return false;
    },
  })
  public guide!: Boolean;

  private activeNav = "";
  show = false;
  accountInfo = {};

  public imgs = {
    AccountBack,
    Account,
    SMSSvg,
  };

  public modalVisible = false;
  public modal1Visible = false;
  public isRecon = false;
  public billContent = {
    billDate: "",
  };
  public modalFrom = {
    email: "",
    btnState: true
  };
  public message:any = [
    // {
    //   id:1,
    //   msg_time:"2024-04-24 08:00:00",
    //   title:"新功能上线",
    //   msg:"订阅新增上线功能 A/B 测试实验，A/B 测试实验有利于您观察订阅工具开启的效果，也有利于您调优训练效果更换的订阅工具。 您可以通过启用 A/B 测试实验，从而获得更优的订阅工具组合",
    //   link:"https://www.baidu.com",
    //   icon:"https://dudwuekkad25.cloudfront.net/Public/cartsee/cartseeImage/9995445b63320418eedbb959745a4545.png"
    // }
  ];
  // public btnState = true;
  public loading = false;
  public messageStatus = false;
  public messageLoading = false;
  public rules: any = {
    email: [
      {
        trigger: "blur",
        validator: async (rule: any, value: any, callback: any) => {
          // 限制中文和空格的输入且只允许输入40个字符
          this.modalFrom.email = value.replace(/[\u4E00-\u9FA5 ]/g, "").slice(0, 40);
          if (
            !new RegExp(
              "[\\w!#$%&'*+/=?^_`{|}~-]+(?:\\.[\\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\\w](?:[\\w-]*[\\w])?\\.)+[\\w](?:[\\w-]*[\\w])?"
            ).test(value)
          ) {
            callback(new Error("请输入正确的邮箱地址"));
          } else {
            this.$set(this.modalFrom, 'btnState',false);
            callback();
          }
        },
      },
      { required: true, message: "请输入邮箱地址", trigger: "blur" },
    ],
  };

  get notice() {
    if (localStorage.getItem('flow-needNotice') === 'true' && localStorage.getItem('campaign-needNotice') === 'true') {
      return '营销活动、营销流程发件人邮箱未完成域名验证，发送邮件时会启用公共邮箱发送邮件。';
    } else if (localStorage.getItem('flow-needNotice') === 'true') {
      return '营销流程发件人邮箱未完成域名验证。';
    } else if (localStorage.getItem('campaign-needNotice') === 'true') {
      return '营销活动发件人邮箱未完成域名验证。';
    } else {
      return '您当前使用的发件人邮箱未完成域名验证，发送邮件时会启用公共邮箱发送邮件。';
    }
  }

  async reDataExport() {
    this.loading = true;
    const { data } = await exportFileByBillDate({
      email: this.modalFrom.email,
      billDate: this.billContent?.billDate,
    });
    this.loading = false;
    if (data) {
      this.modalVisible = false;
      this.modal1Visible = true;
    }
  }

  // 获取最后一条消息的阅读状态
  async getLastMsgReadStatusData() {
    const { data } = await getLastMsgReadStatus({});
    // console.log(data.data,'wqwdqwdqwddqw')
    if (data.data === 0) {
      this.messageStatus = true
    }
  };
  showPopover(){
      this.getLastMsgData()
  }
  afterLeave(){
    this.message = []
  }
  // 获取最后一条消息（单条）
  async getLastMsgData () {
    this.messageLoading = true
    const { data } = await getLastMsg({});
    // console.log(data,'datadatadata----datadata')
    if (data.data&&data.data.msg) {
        // console.log(data)
        this.message = [data.data]
        this.messageStatus = false
        this.messageLoading = false
    }else{
        this.messageLoading = false
    }
  };

  // 控制popover默认是否下拉
  // visible=false

  get name() {
    return this.$store.state.displayInfo.name;
  }
  companyName = localStorage.getItem("companyName");
  companyShow = JSON.parse(localStorage.getItem("companyShow"));

  async getAccountInfo() {
    const { data } = await getAccountInfo({});
    if (data) {
      this.accountInfo = data.data;
    }
  }

  async isShowRecon() {
    const { data } = await showBillDateMenu({});
    if (data.data.billExportModule) {
      this.isRecon = true;
    }
  }

  async getModalContent() {
    const { data } = await getCurrentBillDate({});
    if (data) {
      this.billContent = data.data;
    }
  }

  created() {
    if (
      this.$route.path.indexOf("/strategy/flow") < 0 &&
      this.$route.path.indexOf("/strategy/check") < 0 &&
      this.$route.path.indexOf("/strategy/copy") < 0 &&
      this.$route.path.indexOf("/email/verify") < 0
    ) {
      let newShow = localStorage.getItem("dns-needNotice") || "false";
      this.show = JSON.parse(newShow);
      this.setNav(this.$route, null);

      // 获取账户信息
      this.getAccountInfo();
    }
    this.companyName = localStorage.getItem("companyName");
    this.companyShow = JSON.parse(localStorage.getItem("companyShow"));
    // console.log("🚀 ~ file: yc-header.vue:228 ~ YcHeader ~ created ~ this.companyShow", localStorage.getItem('companyShow'))
    this.isShowRecon();
    this.getModalContent();
  }

  // 判断如果地址栏url中有参数state 则展开popover
  // mounted() {
  //   this.isShowRecon()
  //   this.getModalContent()
  // }

  logout() {
    logout({}).then((res) => {
      localStorage.removeItem("token");
      localStorage.removeItem("timezone");
      localStorage.removeItem("companyInfo");
      localStorage.removeItem("displayInfo");
      sessionStorage.removeItem("sessionDisplayInfo");
      store.commit("CLEAR");
      window.location.href = "/cartsee-new/login";
    });
  }
  reconciliationManagement() {
    this.modalVisible = true;
  }
  updatePassword() {
    window.location.href = "/cartsee-new/updatePassword";
  }
  storeManagement() {
    let path = window.location.pathname + window.location.search;
    window.location.href = `/cartsee-new/storeManagement?${path}`;
  }
  subscribe() {
    // this.$router.push('/subscription/plan')
    window.location.href = "/cartsee-new/subscriptionPlan";
  }
  viewInstructions(node:any){
    // console.log(node, 'nodenode');
    window.open(node.link);
  }
  topages() {
    window.location.href = "/cartsee-new/account?activeTab=2";
  }
  async closeTagValue() {
    let { data, status } = await getGuideNoticeClose({});
    if (status === 200) {
      this.show = false;
      localStorage.setItem("dns-needNotice", String(false));
      this.$router.go(0);
    }
  }
  /**
   * 监控路由变化设置导航激活
   * @param newVal
   * @param oldVal
   */
  @Watch("$route")
  setNav(newVal: any, oldVal: any) {
    this.getLastMsgReadStatusData()
    this.activeNav = newVal.path;
    return (this.activeNav = newVal.path);
  }
}
